import React from "react";
import { SliderArrow } from "src/assets/icons";
import {
  arrowDirection,
  ArrowDirection,
} from "src/components/common/CardSlider/SliderArrows/utils/arrowDirection";

interface SliderArrowButtonProps {
  className?: string;
  to: ArrowDirection;
  onClick?: () => void;
}

export const SliderArrowButton = ({
  className,
  to,
  onClick,
}: SliderArrowButtonProps) => {
  const styleProps = arrowDirection(to);

  return (
    <button
      style={styleProps}
      type="button"
      onClick={onClick}
      className={className}
      aria-label={to}
    >
      <SliderArrow />
    </button>
  );
};

// export const SliderArrowNext = ({
//   className,
//   to,
//   onClick,
// }: SliderArrowProps) => (
//   <button
//     style={{ width: "26px", height: "26px", marginRight: "-10px" }}
//     type="button"
//     onClick={onClick}
//     className={className}
//     aria-label={to}
//   >
//     <SliderArrow style={{ transform: "rotate(180deg)" }} />
//   </button>
// );
